import { createContext } from "react";

import { ValueSetExpansionContains } from "@medplum/fhirtypes";

/** How one question's coding search is limited. */
export type QuestionnaireCodingFilter = {
  /** Keeps only the search results it returns true for. */
  filterOption: (coding: ValueSetExpansionContains) => boolean;
  /** Shown when the search found codes but filterOption hid all of them. */
  filteredOutMessage?: string;
};

/**
 * Set by a drawer to limit what a coding search offers, keyed by the question's linkId. A question
 * with no entry offers every result.
 */
export const QuestionnaireCodingFilterContext = createContext<Record<
  string,
  QuestionnaireCodingFilter
> | null>(null);
